<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="row">
        <div class="col-md-6">
            <div class="tab-heading">
                <span class="tab-heading-title">{{ title }}</span>
                <img
                    alt="Breadcrumb Arrow"
                    class="breadcrumb-separator"
                    src="assets/images/breadcrumb-separator.png" />
                <app-breadcrumb></app-breadcrumb>
            </div>
        </div>
        <div
            class="col-md-6 d-flex justify-content-end align-items-center"
            *ngIf="enterprise?.businessLogo">
            <div id="dashboard-logo">
                <img alt="{{ enterprise?.businessName }} Logo" [src]="enterprise.businessLogo" />
            </div>
        </div>
    </div>
</section>
